import { z } from 'zod';

export const CertificationFormSchema = z.object({
  candidateId: z.string().uuid(),
  institution: z.string(),
  year: z.number(),
  stateExamScore: z.string().nullish(),
  award: z.string(),
});

export type CertificationForm = z.infer<typeof CertificationFormSchema>;
